import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    isMenu: {}, //二级页面菜单
    menuKey: '',//当前选中的二级页面ID
    kstdList: []
  },
  mutations: {
    upIsMenu(state, value) {
      state.isMenu = value
    },
    upMenuKey(state, value) {
      state.menuKey = value
    },
    upKstdList(state, value) {
      state.kstdList = value
    }
  },
  plugins: [persistedState({
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 7 }),
      removeItem: key => Cookies.remove(key)
    }
  })]
})

export default store